export enum AppointmentHistoryStatusEnum {
	BOOKED = 0,
	CONCLUDED = 1,
	CANCELED = 2,
}
